// const getLastSeen = (date  = '2024-12-03T13:45:18.172Z') => {
//     const currentDate = new Date();
//     const inputDate = new Date(date);

//     const timeDifference = currentDate - inputDate;
//     const differenceInSeconds = Math.floor(timeDifference / 1000);
//     const differenceInMinutes = Math.floor(timeDifference / (1000 * 60));
//     const differenceInHours = Math.floor(timeDifference / (1000 * 60 * 60));
//     const differenceInDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

//     if (differenceInSeconds < 60) {
//         return "Just now";
//     }

//     if (differenceInMinutes < 60) {
//         return `${differenceInMinutes} ${differenceInMinutes > 1 ? 'minutes' : 'minute'} ago`;
//     }

//     if (differenceInHours < 24) {
//         return `${differenceInHours} ${differenceInHours > 1 ? 'hours' : 'hour'} ago`;
//     }

//     if (inputDate.toDateString() === currentDate.toDateString()) {
//         const formattedTime = inputDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
//         // return `${formattedTime} Today`;
//         return `Today`;
//     }

//     const yesterday = new Date();
//     yesterday.setDate(currentDate.getDate() - 1);
//     if (inputDate.toDateString() === yesterday.toDateString()) {
//         const formattedTime = inputDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
//         // return `Yesterday at ${formattedTime}`;
//         return `1 day ago`;
//     }

//     if (differenceInDays < 7) {
//         return `${differenceInDays} ${differenceInDays > 1 ? 'days' : 'day'} ago`;
//     }

//     if (inputDate.getFullYear() === currentDate.getFullYear()) {
//         const formattedDate = inputDate.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
//         return formattedDate;
//     }
//     return inputDate.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
// };

export const getJobPostedDate = (date = '') => {
    const currentDate = new Date();
    const inputDate = new Date(date);

    const timeDifference = currentDate - inputDate;
    const differenceInSeconds = Math.floor(timeDifference / 1000);
    const differenceInMinutes = Math.floor(timeDifference / (1000 * 60));
    const differenceInHours = Math.floor(timeDifference / (1000 * 60 * 60));
    const differenceInDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const differenceInMonths = Math.floor(differenceInDays / 30);
    const differenceInYears = Math.floor(differenceInDays / 365);

    if (differenceInSeconds < 60) {
        return "Just now";
    }

    if (differenceInMinutes < 60) {
        return `${differenceInMinutes} ${differenceInMinutes > 1 ? 'minutes' : 'minute'} ago`;
    }

    if (differenceInHours < 24) {
        // return `${differenceInHours} ${differenceInHours > 1 ? 'hours' : 'hour'} ago`;
        return `Posted Today`;
    }

    if (differenceInDays < 30) {
        return `${differenceInDays} ${differenceInDays > 1 ? 'days' : 'day'} ago`;
    }

    if (differenceInMonths < 12) {
        return `${differenceInMonths} ${differenceInMonths > 1 ? 'months' : 'month'} ago`;
    }

    return `${differenceInYears} ${differenceInYears > 1 ? 'years' : 'year'} ago`;
};
